// In-memory + sessionStorage-backed token store for the real Cavan backend.
//
// Access token: memory only, per the API's own guidance — never persisted,
// so an XSS payload reading storage can't walk away with it. It's wiped on
// every full page reload by design; see refreshSession() in authAxios.js
// for how a reload re-establishes a session.
//
// Refresh token: the documented "web" transport is an httpOnly cookie the
// browser manages entirely on its own (this file would never see it). But
// this app's frontend (Vercel) and the API (Render) are on two unrelated
// registrable domains, so whether that cross-site cookie actually survives
// the trip depends on SameSite/Secure config on a server we don't control,
// and can't be verified from here. The API also documents a second,
// explicit-body transport for exactly this situation (this is what it uses
// for the mobile client, which has no shared cookie jar either) — a client
// that sends `refresh_token` in the body simply gets treated as "not web"
// and the server replies the same way. We use that path unconditionally:
// it works regardless of whether the cookie also happens to succeed, and
// it's the one thing here that's fully under our own control.
//
// sessionStorage (not localStorage) so it's wiped when the tab/browser
// closes rather than lingering indefinitely — a deliberate middle ground
// given a "never persist anything" policy would make a page refresh log
// every web user out.
const REFRESH_TOKEN_KEY = 'civ_refresh_token';

let accessToken = null;
let refreshToken = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token || null;
}

export function getRefreshToken() {
  if (refreshToken) return refreshToken;
  try {
    refreshToken = sessionStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    // Storage unavailable (private browsing, disabled storage, etc.) — the
    // session just won't survive a reload; login itself still works.
  }
  return refreshToken;
}

export function setRefreshToken(token) {
  refreshToken = token || null;
  try {
    if (token) sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
    else sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // ignore
  }
}

export function clearTokens() {
  setAccessToken(null);
  setRefreshToken(null);
}
